/**
 * DOM utility type definitions
 */
/**
 * Animation directions
 */
export const DIRECTIONS = {
    left: { reverse: "right" },
    right: { reverse: "left" },
    down: { reverse: "up" },
    up: { reverse: "down" },
    top: { reverse: "bottom" },
    bottom: { reverse: "top" },
    "in": { reverse: "out" },
    out: { reverse: "in" }
};
